import { FC, useContext, useEffect } from 'react';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';
import { CoveragesHomeSection } from '../CoverageHomeSection';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';
import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';

import { ValidateForm } from '../../../../../../../../../shared/utils';

import './index.css';

interface HomeQuotationFormByTabProps {
  tabKey: number | string;
}

export const HomeQuotationFormByTab: FC<HomeQuotationFormByTabProps> = ({
  tabKey,
}) => {
  const { stepThreeHomeQuotationForm } = useContext(StepThreeFormContext);
  const validateForm = new ValidateForm();

  const { planOptionsBySelectedPlan, stepTwoForm } =
    useContext(StepTwoFormContext);

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`);

  const handleDuplicateFields = () => {
    if (planSelected) {
      stepThreeHomeQuotationForm?.setFieldValue(
        `plan-tab-${tabKey}`,
        planSelected
      );
    }
  };

  useEffect(() => {
    handleDuplicateFields();
  }, []);

  return (
    <>
      <ContentSection level='h3' title='Planes'>
        <RowSize>
          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: 'Lista de Planes',
                name: `plan-tab-${tabKey}`,
                rules: validateForm.generateRules({
                  label: 'lista de planes',
                  rules: ['required'],
                }),
              }}
              selectProps={{
                disabled: true,
                options: planOptionsBySelectedPlan,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>

      <CoveragesHomeSection tabKey={tabKey} />
    </>
  );
};
